import { useQuery, useQueryClient } from "@tanstack/react-query";

import { getFootprintingCropSeedingsByPrimaryDataId, getFootprintingCropSeedingsByPrimaryDataIdAdmin } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_CROP_SEEDINGS } from "consts";

export const useGetFootprintingCropSeedingsByPrimaryDataId = (primaryDataId?: string) => {
  const queryClient = useQueryClient();
  const isAdmin = getEnvironment().admin;

  const queryFn = isAdmin ? getFootprintingCropSeedingsByPrimaryDataIdAdmin : getFootprintingCropSeedingsByPrimaryDataId;

  return useQuery(
    {
      queryKey: [FOOTPRINTING_CROP_SEEDINGS, primaryDataId],
      queryFn: () => queryFn(primaryDataId ?? ""),
      enabled: !!primaryDataId,
      gcTime: 0,
    },
    queryClient
  );
};
